import { createAsyncThunk } from '@reduxjs/toolkit';

import instance from 'configs/requests';
import { resetAgreementStatus } from 'pages/Dashboard/Billing/agreements/agreementStore';

export const login = createAsyncThunk('oauth/authentication', async (oauth: IOAuthForm) => {
  const { data } = await instance.post('/clinician-gateway/auth/login', oauth);
  data.roles = JSON.parse(data.roles);
  return data as IUser;
});

export const consumeAuthorizationCode = createAsyncThunk(
  'oauth/consumeAuthorizationCode',
  async (authorizationCode: any) => {
    const { data } = await instance.post('/clinician-gateway/auth/authorization-code', {
      authorization_code: authorizationCode
    });
    data.roles = JSON.parse(data.roles);
    return data as IUser;
  }
);

export const logoutWithDelay = createAsyncThunk('oauth/logout', async () => {
  // Module-level caches outside the store do not reset with it. The agreement re-affirmation is
  // per account, so leaving it behind would hand the next admin to sign in on this browser the
  // previous admin's state.
  resetAgreementStatus();
  await new Promise((resolve) => {
    setTimeout(() => {
      localStorage.setItem('tabsCount', '1');
      resolve(null);
    }, 2000);
  });
  return null;
});
